import { useCallback, useRef, useState } from "react";

const useReadyOnTransitionEnd = (propertyName, fallbackMs) => {
	const [isReady, setIsReady] = useState(false);
	const fallbackTimeoutRef = useRef(null);
	const cleanupRef = useRef(null);

	const ref = useCallback(
		node => {
			cleanupRef.current?.();
			cleanupRef.current = null;
			clearTimeout(fallbackTimeoutRef.current);

			if (!node) {
				return;
			}

			const handleTransitionEnd = event => {
				if (event.target === node && event.propertyName === propertyName) {
					setIsReady(true);
				}
			};

			node.addEventListener("transitionend", handleTransitionEnd);
			fallbackTimeoutRef.current = setTimeout(() => setIsReady(true), fallbackMs);
			cleanupRef.current = () =>
				node.removeEventListener("transitionend", handleTransitionEnd);
		},
		[propertyName, fallbackMs]
	);

	const reset = useCallback(() => {
		cleanupRef.current?.();
		cleanupRef.current = null;
		clearTimeout(fallbackTimeoutRef.current);
		setIsReady(false);
	}, []);

	return [ref, isReady, reset];
};

export default useReadyOnTransitionEnd;
